<div class="card-body">
    <div id="apex-gradient-chart"></div>
</div>